// Données du quiz d'orientation Jesus Talk
// 6 questions courtes → orientent vers 1 des 4 parcours

export const PARCOURS = {
  nouveau: {
    id: "nouveau",
    number: "01",
    title: "Le Nouveau Converti",
    subtitle: "La Naissance",
    tagline: "Fais tes premiers pas avec Jésus.",
    description:
      "Un parcours pour comprendre la nouvelle naissance, apprendre la prière secrète, lire les Évangiles et te détacher des anciennes habitudes par la grâce.",
    color: "from-[#7B98A8] to-[#4A6D82]",
    accent: "#7B98A8",
    emails: 5,
  },
  tiede: {
    id: "tiede",
    number: "02",
    title: "Le Chrétien Tiède",
    subtitle: "Le Réveil & Le Brisement",
    tagline: "Que le feu se rallume.",
    description:
      "Sortir du pilote automatique religieux, identifier ce qui a éteint le feu, retrouver la vraie repentance et accepter le brisement du moi.",
    color: "from-[#C99A5B] to-[#7A5B2E]",
    accent: "#C99A5B",
    emails: 5,
  },
  monde: {
    id: "monde",
    number: "03",
    title: "Vivre Sa Foi",
    subtitle: "La Marche Quotidienne",
    tagline: "Sois sel et lumière au milieu du monde.",
    description:
      "Vivre sa foi au travail, gérer les tensions familiales sans compromis, garder sa vie secrète avec Dieu et rester debout.",
    color: "from-[#4A6D82] to-[#2E4959]",
    accent: "#4A6D82",
    emails: 5,
  },
  traversee: {
    id: "traversee",
    number: "04",
    title: "La Traversée",
    subtitle: "Guérison & Délivrance",
    tagline: "Sors du désert vers la liberté.",
    description:
      "Traverser le silence de Dieu, briser les liens du passé, être guéri intérieurement et sortir de la culpabilité.",
    color: "from-[#2E4959] to-[#0A0806]",
    accent: "#2E4959",
    emails: 5,
  },
};

export const PARCOURS_LIST = Object.values(PARCOURS);

export const QUIZ_QUESTIONS = [
  {
    q: "Comment décris-tu ta relation avec Jésus en ce moment ?",
    answers: [
      { label: "Je viens juste de Le rencontrer", parcours: "nouveau" },
      { label: "Je L'aime mais je me sens un peu tiède", parcours: "tiede" },
      { label: "Je marche avec Lui mais je peine face au monde", parcours: "monde" },
      { label: "Je traverse une saison difficile, je sens Son silence", parcours: "traversee" },
    ],
  },
  {
    q: "Quel est ton plus grand besoin aujourd'hui ?",
    answers: [
      { label: "Comprendre les bases de la foi", parcours: "nouveau" },
      { label: "Retrouver ma première passion", parcours: "tiede" },
      { label: "Vivre ma foi au quotidien concrètement", parcours: "monde" },
      { label: "Être guéri et libéré des blessures du passé", parcours: "traversee" },
    ],
  },
  {
    q: "À quelle fréquence lis-tu la Bible ?",
    answers: [
      { label: "Rarement, je débute à peine", parcours: "nouveau" },
      { label: "Quand j'y pense, c'est irrégulier", parcours: "tiede" },
      { label: "Régulièrement, c'est ma boussole", parcours: "monde" },
      { label: "Je m'y accroche pour tenir dans l'épreuve", parcours: "traversee" },
    ],
  },
  {
    q: "Ta prière ressemble le plus à…",
    answers: [
      { label: "Balbutier, apprendre à parler à Dieu", parcours: "nouveau" },
      { label: "Réciter, sans vraie connexion", parcours: "tiede" },
      { label: "Marcher, converser au fil de la journée", parcours: "monde" },
      { label: "Crier, chercher Sa face dans la souffrance", parcours: "traversee" },
    ],
  },
  {
    q: "Quelle situation te ressemble le plus en ce moment ?",
    answers: [
      { label: "Nouvelle vie en Christ, tout à découvrir", parcours: "nouveau" },
      { label: "Reconversion, je veux revenir à mon appel", parcours: "tiede" },
      { label: "Défis pratiques : travail, famille, tensions", parcours: "monde" },
      { label: "Blessure, deuil ou combat spirituel", parcours: "traversee" },
    ],
  },
  {
    q: "Ce dont tu as le plus soif :",
    answers: [
      { label: "Naître vraiment à Christ", parcours: "nouveau" },
      { label: "Que le feu se rallume dans mon cœur", parcours: "tiede" },
      { label: "Marcher droit dans le monde", parcours: "monde" },
      { label: "Traverser vers la liberté et la guérison", parcours: "traversee" },
    ],
  },
];

export function computeParcours(selectedParcoursIds) {
  const counts = { nouveau: 0, tiede: 0, monde: 0, traversee: 0 };
  selectedParcoursIds.forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
  const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  return sorted[0][0];
}
